<template>
	<v-card class="lcd-display" max-width="135" height="50" :flat="true" :text="channelName"> </v-card>
</template>

<script>
/* Enums */
import SequencerModes from "@/enums/SequencerModes";

/* Libraries */
import emitter from "@/emitter";

export default {
	name: "LCD",

	props: ["channelData", "allChannels"],

	computed: {
		channelName() {
			return this.channelData.name;
		}
	},

	watch: {
		"channelData.name"() {
			this.setControllerChannelName();
		}
	},

	mounted() {
		setTimeout(this.setControllerChannelName, 1000);

		emitter.on("reinitializeMIDI", () => {
			setTimeout(this.setControllerChannelName, 1000);
		});
	},

	methods: {
		setControllerChannelName() {
			if (this.channelData.mode === "master" && this.channelData.assignment) {
				emitter.emit("onSetChannelName", {
					channel: parseInt(this.channelData.assignment.slice(this.channelData.assignment.length - 1)) - 1,
					channelName: SequencerModes.getName(this.channelData.sequencerMode)
				});
			} else if (this.channelData.mode === "track_control") {
				emitter.emit("onSetChannelName", {
					channel: this.channelData.channelNumber - 1,
					channelName: this.channelName
				});
			} else if (this.channelData.assignment != null) {
				emitter.emit("onSetChannelName", {
					channel: this.channelData.channelNumber,
					channelName: this.channelName
				});
			}
		}
	}
};
</script>

<style scoped lang="scss">
.lcd-display {
	display: flex;
	flex-wrap: wrap;
	text-align: center;
	align-content: center;
	background: black !important;
	height: 7%;
	width: 100%;
}

:deep(.v-card-text) {
	color: #00ff00;
	text-transform: uppercase;
	font-size: 1rem;
}
</style>
